export default "/images/5094e58489fe8d263e1399bd1857d5d5.avif";